var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudent41(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#494648",
    d: "M322.81+240.493C322.81+240.493+332.8+328.429+324.059+375.883C315.317+423.337+302.829+402.107+284.098+432.078C275.411+445.976+290.341+454.556+367.141+464.546C443.941+474.537+613.151+473.288+668.722+467.668C724.293+462.049+746.518+453.813+748.644+436.449C752.39+405.854+706.81+405.229+703.688+372.137L711.805+246.805"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "",
    opacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#d8a9f7",
    d: "M876.999+915.886L183.402+915.886C165.861+915.886+152.367+901.685+153.262+884.167L167.853+598.697C167.853+527.055+232.424+483.214+281.359+478.515L413.788+469.661L622.622+469.234L747.281+478.515C808.61+483.214+860.787+527.055+860.787+598.697L876.999+915.886Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdd4af",
    d: "M511.722+110.569L519.278+110.569C617.868+110.569+697.791+196.81+697.791+303.194L697.791+303.194C697.791+409.578+617.868+495.819+519.278+495.819L511.722+495.819C413.131+495.819+333.208+409.578+333.208+303.194L333.208+303.194C333.208+196.81+413.131+110.569+511.722+110.569Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.641+350.256L518.054+350.256C575.632+350.256+622.309+400.324+622.309+462.085L622.309+462.085C622.309+523.847+575.632+573.914+518.054+573.914L513.641+573.914C456.062+573.914+409.386+523.847+409.386+462.085L409.386+462.085C409.386+400.324+456.062+350.256+513.641+350.256Z",
    opacity: 1,
    fill: "#fdd4af"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M512.804+55.1947C603.552+50.2542+699.649+126.935+716.642+237.834C716.703+251.794+709.72+252.125+692.453+250.406C661.251+247.299+616.273+243.878+572.566+239.01C562.004+237.833+555.707+149.497+555.707+149.497C555.707+149.497+559.104+233.89+552.477+237.582C536.867+246.282+469.487+236.415+458.572+237.315C450.376+237.992+458.302+146.454+458.302+146.454C458.302+146.454+448.701+236.041+441.444+236.723C410.022+239.677+316.451+251.586+319.063+235.307C336.546+126.371+416.345+60.4461+512.804+55.1947Z",
    fill: "#494648"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent41);
export default __webpack_public_path__ + "static/media/Student 41.5d0189ed388f79774d8650e938010344.svg";
export { ForwardRef as ReactComponent };